import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Z-Filter";

const callZImageEnhancer = async (
	denoise: number,
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$image: imageBase64,
					$denoise: denoise,
				},
				jwt,
				tool_document_id,
			};
			return fetchGatewayInferenceJob(data, executionContext, messageId);
		},
	});
	return success;
};

export function useListenZImageEnhancerMessage() {
	useListenFromRenderer([
		{
			key: "zImageEnhancer",
			onMessage: async (message) => {
				const success = await callZImageEnhancer(
					message.values.denoise,
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
